/**
 * Hook per accedere al servizio toast
 * Facilita l'uso del toast nei componenti React
 */
import { toast } from "@/lib/toast-service";

/**
 * Hook che restituisce il servizio toast
 * @returns Oggetto con funzioni per mostrare toast
 */
export function useToast() {
    return toast;
}
